module.exports = __webpack_public_path__ + "components/flag/static/square/gl-0a1fdb9aa092b8a56bcc47336f62cab4.svg";